export default "__VITE_ASSET__mHpJUJOa__"